import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, Suspense as _Suspense } from "vue"

const _hoisted_1 = { class: "content-grid content-grid--subpage" }
const _hoisted_2 = { class: "content-grid__header" }
const _hoisted_3 = {
  key: 0,
  class: "util--text-grey"
}

import Loader from "@/components/layout/Loader.vue";
import {useI18n} from "vue3-i18n";
import Breadcrumbs from "@/components/layout/Breadcrumbs.vue";
import BackLinkTitle from "@/components/layout/BackLinkTitle.vue";
import {useOrganizationService} from "@/inversify.config";
import {onMounted, ref} from "vue";
import Card from "@/components/layout/Card.vue";
import MemberTable from "@/components/tables/MemberTable.vue";
import ContactTable from "@/components/tables/ContactTable.vue";
import InvoiceTable from "@/components/tables/InvoiceTable.vue";
import CorporatePageViewStatsCard from "@/views/admin/components/CorporatePageViewStatsCard.vue";
import {IFullOrganization} from "@/types/entities/organization";
import {notifyError, notifySuccess} from "@/notify";
import {getFileFromUrl, getValueForLocale} from "@/helpers";
import {Invoice} from "@/types/entities";
import {OrganizationType} from "@/types";
import OrganizationForm from "@/components/forms/OrganizationForm.vue";
import {IEditOrganizationRequest} from "@/types/requests";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminOrganizationView',
  props: {
    organizationId: {}
  },
  setup(__props: any) {

const props = __props;

const {t} = useI18n()
const organizationService = useOrganizationService();

const organizationLogo = ref<File>()
const organization = ref<IFullOrganization>();
const organizationInvoices = ref<Invoice[]>([]);
const organizationIsLoading = ref(false);

const addMemberPath = {name: 'admin.children.organizations.addMember', params: {organizationId: props.organizationId}};
const addContactPath = {
  name: 'admin.children.organizations.addContact',
  params: {organizationId: props.organizationId}
};

onMounted(() => {
  loadOrganization()
})

async function loadOrganization() {
  organizationIsLoading.value = true;
  let fullOrganization = await organizationService.getOrganizationWithId(props.organizationId)
  if (fullOrganization) {
    organization.value = fullOrganization;
    organizationInvoices.value = getInvoices()
    if (fullOrganization.logo)
      organizationLogo.value = await getFileFromUrl(fullOrganization.logo, fullOrganization.logo)
  }
  organizationIsLoading.value = false;
}

function getInvoices(): Invoice[] {
  if (!organization.value)
    return [];
  organization.value?.subscription.invoices?.forEach(x => {
    x.description = `${t(`products.membershipPlan`)} : ${x.createdAt}`
  })
  organization.value.memberInvoices.forEach(x => {
    x.description = `${t(`activities.activityRegistration`)} ${getValueForLocale(x.productName)} ${t('global.table.of')} ${x.memberFullName}`
  })
  return organization.value?.subscription.invoices.concat(organization.value.memberInvoices);
}

async function onImageChange(file: File) {
  organizationLogo.value = file
}

async function handleSubmit(organization: IFullOrganization) {
  let request: IEditOrganizationRequest = {
    id: organization.id,
    type: organization.type,
    logo: organizationLogo.value,
    email: organization.email,
    phoneNumber: organization.phoneNumber,
    phoneExtension: organization.phoneExtension,
    apartment: organization.apartment,
    street: organization.street,
    city: organization.city,
    zipCode: organization.zipCode,
    enterpriseNumber: organization.enterpriseNumber,
    website: organization.website,
    numberOfUnits: organization.numberOfUnits,
    yearsOfExperience: organization.yearsOfExperience,
    brokerType: organization.brokerType,
    activityAreas: organization.activityAreas,
    descriptionFr: organization.descriptionFr,
    descriptionEn: organization.descriptionEn,
    hasContingencyFundCertification: organization.hasContingencyFundCertification
  };
  let succeededOrNotResponse = await organizationService.editOrganizationWithId(props.organizationId, request)
  if (succeededOrNotResponse && succeededOrNotResponse.succeeded) {
    notifySuccess(t('validation.organization.update.success'))
  } else {
    let errorMessages = succeededOrNotResponse.getErrorMessages(
        'validation.organization.update', 'validation.organization.update.errorOccurred');
    notifyError(errorMessages[0])
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Suspense, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Breadcrumbs, {
          title: _unref(t)(`routes.admin.children.organizations.view.name`)
        }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(BackLinkTitle, {
            title: _unref(t)('routes.admin.children.organizations.view.name')
          }, null, 8, ["title"]),
          (organization.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(`${_unref(t)('organization.modifiedOn')} ${organization.value.lastModified.toLocalDateTimeString()}`), 1))
            : _createCommentVNode("", true)
        ]),
        (organization.value)
          ? (_openBlock(), _createBlock(Card, {
              key: 0,
              title: organization.value.name
            }, {
              default: _withCtx(() => [
                _createVNode(OrganizationForm, {
                  modelValue: organization.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((organization).value = $event)),
                  onSubmit: handleSubmit,
                  onOnImageChange: onImageChange
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true),
        (organization.value && organization.value.type === _unref(OrganizationType).Corporate)
          ? (_openBlock(), _createBlock(CorporatePageViewStatsCard, {
              key: 1,
              "organization-id": organization.value.id.toString()
            }, null, 8, ["organization-id"]))
          : _createCommentVNode("", true),
        (organization.value)
          ? (_openBlock(), _createBlock(MemberTable, {
              key: 2,
              "card-link-path": addMemberPath,
              "hide-card-link": organization.value.type == _unref(OrganizationType).Corporate && organization.value.members.length > 0,
              "is-loading": organizationIsLoading.value,
              members: organization.value.members,
              "organization-id": organization.value.id.toString()
            }, null, 8, ["hide-card-link", "is-loading", "members", "organization-id"]))
          : _createCommentVNode("", true),
        (organization.value && organization.value.type === _unref(OrganizationType).Corporate)
          ? (_openBlock(), _createBlock(ContactTable, {
              key: 3,
              "card-link-path": addContactPath,
              contacts: organization.value.contacts,
              "is-loading": organizationIsLoading.value,
              "organization-id": organization.value.id.toString()
            }, null, 8, ["contacts", "is-loading", "organization-id"]))
          : _createCommentVNode("", true),
        (organization.value)
          ? (_openBlock(), _createBlock(InvoiceTable, {
              key: 4,
              invoices: organizationInvoices.value,
              "is-loading": organizationIsLoading.value
            }, null, 8, ["invoices", "is-loading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    fallback: _withCtx(() => [
      _createVNode(Loader)
    ]),
    _: 1
  }))
}
}

})